import moment from "moment";
import { AppModel } from "../_Utils/AppModel";
import { Watchable } from "../_Utils/Watchable";
import { TDealerGroupAttr } from "./Types";

export type DealerGroupEventMap = {
    ATTRIBUTES_UPDATED: TDealerGroupAttr;
};

class DealerGroupData extends Watchable<DealerGroupEventMap> {
    constructor(attrs: TDealerGroupAttr) {
        super();
        this.attrs = attrs;
        this.cAttrs = attrs;
    }

    private cAttrs: TDealerGroupAttr;

    set attrs(atr: TDealerGroupAttr) {
        atr.createdAt = moment(atr.createdAt);
        atr.updatedAt = moment(atr.updatedAt);
        this.cAttrs = atr;
        this.trigger("ATTRIBUTES_UPDATED", atr);
    }

    get attrs() {
        return this.cAttrs;
    }
}

export class DealerGroup extends AppModel<DealerGroupData> {
    public data: DealerGroupData;
    public readonly type = "dgroup";
    public readonly id;
    constructor(attributes: TDealerGroupAttr) {
        super();
        this.data = new DealerGroupData(attributes);
        this.id = attributes._id;
    }
}
